import React, { useState, useEffect, useRef } from "react";
import ApplicationsList from "./ApplicationsList";
import GuideForm from "./GuideForm";
import { usePopup } from "./PopupContext";

const ManageApplicants = () => {

    const hasFetched = useRef(false)
    const isApplicant = true
    const [applicants, setApplicants] = useState([]);
    const [showApplicationDetails, setShowApplicationDetails] = useState(false);
    const [selectedApplicant, setSelectedApplicant] = useState(null);
    const [guideTypes, setGuideTypes] = useState([])
    const pop = usePopup()

    const onShowApplicantDetails = (bool) => {
        setSelectedApplicant(bool);
        setShowApplicationDetails(bool);
    }

    // Fetch applicants data from API
    const fetchApplicants = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/applicants`, {
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem('adminToken')}`
            }
        });
        const data = await response.json();
        if (data.success) {
            setApplicants(data.applicants);
        } else {
            console.error("Failed to fetch applicants");
        }
    };

    // Fetch guide types data from API
    const fetchGuideTypes = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guide-types`, {
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem('adminToken')}`
            }
        });
        const data = await response.json();
        if (data.success) {
            setGuideTypes(data.guideTypes);
        } else {
            console.error("Failed to fetch guides");
        }
    }

    const updateApplicant = async (applicant) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guide`, {
                method: 'PATCH',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem('adminToken')}`
                },
                body: JSON.stringify(applicant)
            });
            const data = await response.json();
            if (data.success) {
                pop(data.message, 'flash', data.success)
                onShowApplicantDetails(false);
                fetchApplicants();
            } else {
                pop(data.message, 'flash', data.success)
                console.error("Failed to update guide");
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (!hasFetched.current) {
            hasFetched.current = true
            fetchGuideTypes()
        }
        fetchApplicants();
    }, []);

    return (
        <section className="main-body-section manage-applicants-section">
            {!showApplicationDetails && applicants.length > 0 && <ApplicationsList applicants={applicants} onShowApplicantDetails={onShowApplicantDetails} />}
            {!showApplicationDetails && applicants.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 20 }}>
                    <h3>No applicants found.</h3>
                    <p>Please check back later.</p>
                </div>
            )}
            {showApplicationDetails && selectedApplicant && (
                <GuideForm 
                    isApplicant={isApplicant}
                    guideTypes={guideTypes}
                    selectedGuide={selectedApplicant}
                    updateGuide={updateApplicant}
                    setShowGuideDetails={setShowApplicationDetails}/>
            )}
        </section>
    );
}

export default ManageApplicants;